import { render, staticRenderFns } from "./FavoriteProducts.vue?vue&type=template&id=6e8aa98c&scoped=true&"
import script from "./FavoriteProducts.vue?vue&type=script&lang=js&"
export * from "./FavoriteProducts.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteProducts.vue?vue&type=style&index=0&id=6e8aa98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8aa98c",
  null
  
)

export default component.exports